export default "__VITE_ASSET__ffb43df3__"